export const getDummyQuestionPracticeSkill = function (question_code, practice_id) {
    return {
        question_code,
        practice_skill_id: '',
        dok: null,
        correct_answer: null,
        max_points: 1,
        questions: null,
        domain: null,
        mode: null,
        grading_instructions: null,
        practice_id
    }
}
export const isNumeric = function (num) {
    return (num.toString() === parseFloat(num).toString());
}
